__turbopack_context__.v({
  "className": "work_sans_a64edbb9-module__NAwRUa__className",
  "variable": "work_sans_a64edbb9-module__NAwRUa__variable",
});
